import { Link } from "react-router-dom";
import "./CardGrid.css";

export default function CardGrid({ items = [] }) {
  return (
    <section className="grid">
      {items.map((item) => {
        // Determine CTA (default fallback)
        const cta = item.cta || { label: "Inquire", href: "/contact" };

        // Determine Read More route
        let readMoreLink = null;
        if (item.longDescription || item.longContent) {
          if (item.type === "hotels") {
            readMoreLink = `/hotels/${item.id.toString()}`; // ensure string
          } else if (item.category && item.id != null) {
            readMoreLink = `/packages/${item.category}/${item.id.toString()}`; // ensure string
          }
        }

        // Safe href
        const ctaHref = typeof cta?.href === "string" ? cta.href : "";

        return (
          <article key={item.id} className="card">
            {/* Image */}
            {item.image ? (
              <img src={item.image} alt={item.title} className="card-image" />
            ) : (
              <div className="card-placeholder">No image</div>
            )}

            {/* Card Body */}
            <div className="card-body">
              <h3>{item.title}</h3>
              {item.location && <p className="muted">📍 {item.location}</p>}
              <p>{item.shortDescription || item.description}</p>

              {/* Rating */}
              {item.rating && (
                <div className="rating">
                  {[...Array(5)].map((_, i) => (
                    <span
                      key={i}
                      className={`star ${i < item.rating ? "filled" : ""}`}
                    >
                      ★
                    </span>
                  ))}
                </div>
              )}

              {/* Actions */}
              <div className="card-actions">
                {readMoreLink ? (
                  <Link className="btn" to={readMoreLink}>
                    Read More
                  </Link>
                ) : typeof ctaHref === "string" && ctaHref.startsWith("/") ? (
                  <Link className="btn" to={ctaHref}>
                    {cta.label}
                  </Link>
                ) : (
                  <a
                    className="btn"
                    href={ctaHref || "/contact"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {cta.label}
                  </a>
                )}
              </div>
            </div>
          </article>
        );
      })}
    </section>
  );
}
